export default __webpack_public_path__ + "static/media/soroush-karimi.ac7a7af4.jpg";